/* eslint-disable import/order */
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "authConfig";
import ROUTERS_PATHS from "consts/router-paths";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// eslint-disable-next-line import/prefer-default-export
export const msalInstance = new PublicClientApplication(msalConfig as any);
const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <>
    {window.location.pathname.includes(ROUTERS_PATHS.BLANK) ? (
      <>Redirect...</>
    ) : (
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    )}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
